import React from 'react';
import { heroData } from '../data/mock';
import { Building2, Linkedin, Mail, ArrowUp, Instagram, Facebook } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navLinks = [
    { label: 'Biography', hash: '#biography' },
    { label: 'Achievements', hash: '#achievements' },
    { label: 'Timeline', hash: '#timeline' },
    { label: 'Contact', hash: '#contact' },
  ];

  const connectLinks = [
    { label: 'Email', href: 'mailto:rwargner@redspire-eng.com', Icon: Mail },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/ruben-wargner-59a83b336', Icon: Linkedin },
    { label: 'Instagram', href: 'https://www.instagram.com/rubenwargner', Icon: Instagram },
    { label: 'Facebook', href: 'https://www.facebook.com/RubenWargneer/', Icon: Facebook },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavClick = (event, hash) => {
    event.preventDefault();

    const scrollToSection = () => {
      const section = document.querySelector(hash);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    if (location.pathname === '/') {
      scrollToSection();
    } else {
      navigate({ pathname: '/', hash });
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <Building2 size={32} />
              <span>Redspire</span>
            </div>
            <p className="footer-tagline">
              Engineering legacies that span generations.
            </p>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h4>Navigation</h4>
              {navLinks.map((link) => (
                <a
                  key={link.hash}
                  href={link.hash}
                  onClick={(event) => handleNavClick(event, link.hash)}
                >
                  {link.label}
                </a>
              ))}
            </div>
            
            <div className="footer-column">
              <h4>Connect</h4>
              {connectLinks.map(({ label, href, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target={href.startsWith('http') ? '_blank' : undefined}
                  rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
                >
                  <Icon size={16} /> {label}
                </a>
              ))}
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="copyright">
            © {new Date().getFullYear()} {heroData.name}. All rights reserved.
          </p>
          <button className="scroll-top-btn" onClick={scrollToTop}>
            <ArrowUp size={20} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
